import _regeneratorRuntime from "D:/\u9879\u76EE/blueSkyReportForm/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js";
import _asyncToGenerator from "D:/\u9879\u76EE/blueSkyReportForm/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _slicedToArray from "D:/\u9879\u76EE/blueSkyReportForm/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
import "core-js/modules/es.number.constructor.js";
import { defineComponent, computed } from 'vue';
import { useRouter } from 'vue-router';
import useSignReleaseSlave from '../hooks/useSignReleaseSlave';
export default defineComponent({
  name: 'MaterialItem',
  components: {},
  props: {
    item: {
      type: Object,
      required: true
    },
    index: {
      type: Number,
      required: true
    },
    show_status: {
      type: Boolean,
      required: true
    }
  },
  emits: ['update-list'],
  setup: function setup(props, _ref) {
    var emit = _ref.emit;
    var router = useRouter();
    // const toRequest = () => {
    //   router.push({
    //     name: 'MaterialPositionInfo',
    //     params: {
    //       id: props.item.id,
    //       release_nums: props.item.release_nums,
    //       release_unit: props.item.release_unit,
    //       stone_id: props.item.stone_id,
    //       stone_specifications: props.item.stone_specifications,
    //       inventory_no: 'JSKC2022031500001'
    //     }
    //   })
    // }
    var params = computed(function () {
      return {
        id: props.item.id,
        inventory_no: props.item.archives[0].inventory_no,
        execute_nums: props.item.release_nums,
        sign_type: props.item.release_status ? 0 : 1 //1标记为已领 0标记为未领
      };
    });
    //确认领用
    var _useSignReleaseSlave = useSignReleaseSlave(params),
      _useSignReleaseSlave2 = _slicedToArray(_useSignReleaseSlave, 1),
      signReleaseSlaveAsync = _useSignReleaseSlave2[0];
    var markReceived = /*#__PURE__*/function () {
      var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return signReleaseSlaveAsync();
            case 2:
              emit('update-list');
            case 3:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }));
      return function markReceived() {
        return _ref2.apply(this, arguments);
      };
    }();
    return {
      markReceived: markReceived
    };
  }
});